import React from 'react';
import Helmet from 'react-helmet';
import filter from 'lodash/filter';
import omitBy from 'lodash/omitBy';

const publicUrl = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}` : '';

const scripts = [
  {
    _name: 'FontAwesome',
    _env: ['development', 'sandbox', 'production'],
    type: 'text/javascript',
    src: `${publicUrl}/fontawesome-pro/js/fontawesome-all.min.js`,
    async: true,
  },
];

export default () => {
  const env = process.env.REACT_APP_ENV || 'development';
  const scriptsByEnv = filter(scripts, { _env: [env] });
  const sanitizedScripts = scriptsByEnv.map(script => {
    return omitBy(script, (val, key) => key[0] === '_');
  });

  return <Helmet script={sanitizedScripts} />;
};
